import React from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

const Footer = () => {
  const { settings, loading } = useSettings();
  const location = useLocation();

  // Check if current route is "/"
  const isHome = location.pathname === "/";

  return (
    <footer
      className="w-full bg-white flex flex-col justify-end"
      style={{ minHeight: isHome ? "50vh" : "10vh" }}
    >
      {/* Bottom Black Bar */}
      <div className="w-full bg-black text-white text-center py-6">
        <p className="text-sm md:text-base font-medium tracking-wide">
          © {new Date().getFullYear()}{" "}
          {loading
            ? "Loading..."
            : settings?.resturant_name || "Restaurant"}
          . All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;